import { createApp } from 'vue';
import App from './App.vue';
import './global.css';

createApp(App).mount('#app');
